import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <footer
            className="relative rounded-tl-[40px] rounded-tr-[40px] border border-white/15 overflow-x-hidden max-w-full"
            style={{
                background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15)',
                backdropFilter: 'blur(30px)',
            }}
        >
            {/* Main Content Container */}
            <div className="relative px-[24px] sm:px-6 md:px-12 lg:px-24 py-12 sm:py-16">
                <div className="flex flex-col lg:flex-row justify-between items-start gap-10 lg:gap-12">
                    {/* Logo and Tagline */}
                    <div className="flex-shrink-0 w-full sm:max-w-[366px]">
                        <div className="mb-4">
                            <img src="/icons/footer_logo.svg" alt="Hush" className="h-[40px] sm:h-[52px] w-auto" />
                        </div>
                        <p
                            className="font-manrope text-[12px] sm:text-[13px] leading-[18px] sm:leading-5 text-white mt-3"
                        >
                            Built to connect companies with top passive talent worldwide
                        </p>
                    </div>

                    {/* Navigation Menu */}
                    <div className="flex flex-col sm:flex-row flex-wrap gap-8 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-20">
                    {/* Product Column */}
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2.5 px-0 sm:px-2.5 py-2.5 mb-2">
                            <div className="w-5 h-px bg-white/10 rotate-90" />
                            <h3 className="font-manrope font-medium text-lg sm:text-2xl leading-5 text-white">
                                Product
                            </h3>
                        </div>
                        <ul className="space-y-0">
                            <li>
                                <Link
                                    to="/features"
                                    className="block px-2 sm:px-5 py-2 sm:py-2.5 font-manrope text-[12px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                                >
                                    Features
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/candidates"
                                    className="block px-2 sm:px-5 py-2 sm:py-2.5 font-manrope text-[12px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                                >
                                    For Candidates
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/employers"
                                    className="block px-2 sm:px-5 py-2 sm:py-2.5 font-manrope text-[12px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                                >
                                    For Employers
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Company Column */}
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2.5 px-0 sm:px-2.5 py-2.5 mb-2">
                            <div className="w-5 h-px bg-white/10 rotate-90" />
                            <h3 className="font-manrope font-medium text-lg sm:text-2xl leading-5 text-white">
                                Company
                            </h3>
                        </div>
                        <ul className="space-y-0">
                            <li>
                                <Link
                                    to="/contact"
                                    className="block px-2 sm:px-5 py-2 sm:py-2.5 font-inter text-[12px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                                >
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Column */}
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2.5 px-0 sm:px-2.5 py-2.5 mb-2">
                            <div className="w-5 h-px bg-white/10 rotate-90" />
                            <h3 className="font-manrope font-medium text-lg sm:text-2xl leading-5 text-white">
                                Contact
                            </h3>
                        </div>
                        <ul className="space-y-0">
                            <li>
                                <a
                                    href="mailto:info@hush.com"
                                    className="block px-2 sm:px-5 py-2 sm:py-2.5 font-inter text-[12px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                                >
                                    info@hush.com
                                </a>
                            </li>
                            <li className="px-2 sm:px-5 py-2 sm:py-2.5 font-inter text-[12px] sm:text-[13px] leading-5 text-white/70">
                                New York, NY
                            </li>
                        </ul>
                    </div>

                    {/* Follow Us */}
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center gap-2.5 py-2.5 pr-0 sm:pr-5">
                            <div className="w-5 h-px bg-white/10 rotate-90" />
                            <h3 className="font-manrope font-medium text-lg sm:text-xl leading-5 text-white capitalize">
                                follow us
                            </h3>
                        </div>
                        <div className="flex gap-2.5 opacity-60">
                            <a
                                href="https://x.com/hushtalentinc"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/50 transition-all hover:scale-110"
                                style={{
                                    backdropFilter: 'blur(10px)',
                                    background: 'rgba(255, 255, 255, 0.6)',
                                    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px 10px 10px rgba(0, 0, 0, 0.1)'
                                }}
                                aria-label="X (Twitter)"
                            >
                                <img src="/icons/footer_x.svg" alt="X" className="w-4 h-4" />
                            </a>
                            <a
                                href="https://www.instagram.com/hushtalentinc?igsh=MTF6cTVwOHNxMXdiMA%3D%3D&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/50 transition-all hover:scale-110"
                                style={{
                                    backdropFilter: 'blur(10px)',
                                    background: 'rgba(255, 255, 255, 0.6)',
                                    boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05), 0px 4px 4px rgba(0, 0, 0, 0.05), 0px 10px 10px rgba(0, 0, 0, 0.1)'
                                }}
                                aria-label="Instagram"
                            >
                                <img src="/icons/footer_insta.svg" alt="Instagram" className="w-4 h-4" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {/* Bottom Bar */}
            <div className="relative min-h-[60px] flex flex-col sm:flex-row items-center justify-between px-[24px] sm:px-6 md:px-12 lg:px-24 py-5 border-t border-white/10 gap-4">
                <p className="font-inter text-[11px] sm:text-[13px] leading-5 text-white/70 text-center sm:text-left">
                    © 2025 Hush. All rights reserved.
                </p>
                <div className="flex items-center gap-10">
                    <div className="flex items-center gap-3 sm:gap-4">
                        <Link
                            to="/terms-of-service"
                            className="font-manrope text-[11px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                        >
                            Terms of Service
                        </Link>
                        <div className="h-px w-[17px] bg-white/10 rotate-90" />
                        <Link
                            to="/privacy-policy"
                            className="font-manrope text-[11px] sm:text-[13px] leading-5 text-white/70 hover:text-white transition-colors"
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
